import { ChangeDetectorRef, Component, ElementRef, Input, OnChanges, OnInit, QueryList, Renderer2, SimpleChanges, ViewChildren } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { EditorModule } from 'primeng/editor';
import { DropdownChangeEvent, DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ContentEditorComponent, EditorContent } from '../../../utility/content-editor/content-editor.component';
import { MessageService } from 'primeng/api';
import { EssayPilotService } from '../../../services/essay-pilot/essay-pilot.service';
import { essayOptions } from '../essay-pilot.component';
import { DialogModule } from 'primeng/dialog';
import { RecentSubmissionsComponent } from '../recent-submissions/recent-submissions.component';
import { PastEssaySubmissionResponse } from '../../../models/essay-pilot/pastEssaySubmissionResponse';
import { Store } from '@ngxs/store';
import { UserStateModel } from '../../../states/user/user-state-model';
import { UserSelectors } from '../../../states/user/user-selector';
import { EssayCommentResponse } from '../../../models/essay-pilot/essayCommentResponse';
import { of, switchMap } from 'rxjs';

@Component({
  selector: 'app-essay-editor',
  standalone: true,
  imports: [ButtonModule, RecentSubmissionsComponent, EditorModule, DropdownModule, FormsModule, CommonModule, ContentEditorComponent, DialogModule],
  templateUrl: './essay-editor.component.html',
  styleUrl: './essay-editor.component.scss'
})
export class EssayEditorComponent implements OnInit {
  constructor(private messageService: MessageService,
    private essayService: EssayPilotService,
    private store: Store,
    private essayPilotService: EssayPilotService,
    private cdr: ChangeDetectorRef
  ) { }
  ngOnInit(): void {
    this.getUser();
    // this.getPendingComments();
  }

  @Input() essays: essayOptions[] = [];
  selectedEssay: essayOptions | undefined;
  initialContent: string = '';
  essaytextContent: string = '';
  essayhtmlContent: string = '';
  totalWords: number = 0;
  essayId?: number;
  isLoading: boolean = false;

  visible: boolean = false;
  isLoadingPastSubmssions: boolean = false;

  pastSubmissions: PastEssaySubmissionResponse[] = [];
  latestSubmission: PastEssaySubmissionResponse | undefined;
  commentList: EssayCommentResponse[] = [];
  user: UserStateModel | undefined;


  resetEditorsContent() {
    const editor = document.querySelector('.ql-editor');
    if (editor) {
      // Overwrite the inner HTML of the editor
      editor.innerHTML = this.initialContent;
    }
  }

  onEssayContentChange($event: EditorContent) {
    this.essaytextContent = $event.textValue;
    this.essayhtmlContent = $event.htmlValue;
    this.totalWords = this.essaytextContent.trim().split(/\s+/).filter(word => word).length;
    this.cdr.detectChanges();
  }

  onSubmit() {
    if (!this.selectedEssay || !this.essaytextContent) {
      return;
    } else {
      // if (this.totalWords > 650) {
      //   this.messageService.add({ severity: 'error', summary: 'Invalid', detail: `Words can't exceed 650 limit` });
      //   return;
      // }
      this.isLoading = true;
      const saveOrUpdate$ = this.essayId
        ? this.essayService.updateStudentEssayAnswer(this.essayId.toString(), {
          question: this.selectedEssay.title ?? '',
          answer: this.essaytextContent,
          htmlAnswer: this.essayhtmlContent ?? '',
        })
        : this.essayService.saveStudentEssayAnswer({
          question: this.selectedEssay.title ?? '',
          answer: this.essaytextContent,
          htmlAnswer: this.essayhtmlContent ?? '',
        });

      saveOrUpdate$.subscribe({
        next: () => {
          this.isLoading = false;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: `Answer is ${this.essayId ? 'updated' : 'saved'
              }!`,
          });
        },
        error: (error) => {
          this.isLoading = false;
          console.error('Error saving/updating essay:', error);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'An error occurred while saving your essay.',
          });
        },
      });
    }
  }

  onEssayChange($event: DropdownChangeEvent) {
    this.essayService.getStudentEssayAnswer({
      question: $event.value.title ?? ''
    }).subscribe({
      next: (respone) => {
        this.essaytextContent = respone.answer ?? '';
        this.essayhtmlContent = respone.htmlAnswer ?? '';
        this.initialContent = respone.htmlAnswer ?? '';
        this.essayId = respone.id;
        this.totalWords = this.essaytextContent.trim().split(/\s+/).filter(word => word).length;
        this.cdr.detectChanges();
        // this.resetEditorsContent();
        this.getPendingComments();
      },
      error: (error) => {
        this.essayId = undefined;
        this.essaytextContent = ''
        this.totalWords = 0;
        this.essayhtmlContent = '';
        this.initialContent = '';
        this.cdr.detectChanges();
        this.resetEditorsContent();
        console.warn(`error while saving answer:${error}`);
      }
    });
  }

  getPendingComments() {
    this.essayService.getPastSubmissions({
      question: this.selectedEssay?.title ?? '',
      studentId: this.user?.id ?? '',
    }).pipe(
      switchMap(submissions => {
        this.latestSubmission = submissions.result[submissions.result.length - 1] ?? undefined;
        console.log(this.latestSubmission);
        if (this.latestSubmission?.id) {
          return this.essayPilotService.getEssayComments({
            pastEssaySubmissionId:this.latestSubmission?.id,
            status: 0
          });
        } else {
          this.messageService.add({ severity: 'warn', summary: 'Not Found', detail: 'No Submission found', life: 3000 });
          return of({ result: [] }); // Return an observable with an empty result
        }
      })
    ).subscribe({
      next: (response) => {
        this.commentList = response.result;
      },
      error: (err) => {
        console.warn(`error while retriving essay comment list:${err}`);
      }
    });
  }

  updateCommentStatus(commentId: number) {
    this.isLoading = true;
    this.essayPilotService.updateCommentStatus(commentId).subscribe({
      next: (response) => {
        this.isLoading = false;
        const index = this.commentList.findIndex(comment => comment.id === commentId);
        if(index > -1){
          this.commentList.splice(index, 1);
        }
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Comment status updated successfully!' });
      },
      error:(err) => {
        this.isLoading = false;
        console.warn(`error while updating comment status:${err}`);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'An error occurred while updating comment status.' });
      }
    })
  }

  getRecentSubmissions() {
    this.isLoadingPastSubmssions = true;
    this.essayService.getPastSubmissions({
      question: this.selectedEssay?.title ?? '',
      studentId: this.user?.id ?? '',
    }).subscribe({
      next: (submissions) => {
        this.isLoadingPastSubmssions = false;
        this.pastSubmissions = submissions.result ?? [];
        if (submissions.result.length > 0) {
          this.showDialog();
        }
        else {
          this.messageService.add({ severity: 'warn', summary: 'Not Found', detail: 'No Submission found', life: 3000 });
        }
      },
      error: (error) => {
        this.isLoadingPastSubmssions = false;
        this.messageService.add({ severity: 'warn', summary: 'Not Found', detail: 'No Submission found', life: 3000 });
      },
    });
  }

  showDialog() {
    this.visible = true;
  }

  getUser() {
    this.store.select(UserSelectors.getUser).subscribe({
      next: (response) => {
        this.user = response;
      },
      error: (error) => {
        console.warn('Error fetching user:', error);
      }
    });
  }



}
